import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN
const get = path => axios.get(origin + path).then(response => response.data)
const post = (path, payload) => axios.post(origin + path, payload).then(response => response.data)

export default {
  getUsers () {
    return get('/access-management/provider-role-management/users')
  },
  getRoles () {
    return get('/access-management/provider-role-management/roles')
  },
  assignRole (payload) {
    return post('/access-management/provider-role-management/assign', payload)
  },
  removeRole (payload) {
    return post('/access-management/provider-role-management/remove', payload)
  }
}
